function initStickyPromoBarClogs(root) {
  root.querySelectorAll('[data-sticky-promo-clogs]').forEach(function (holder) {
    if (holder.dataset.stickyPromoInit) return;
    holder.dataset.stickyPromoInit = 'true';

    var bar = holder.querySelector('.sticky-promo-bar-clogs');
    if (!bar) return;

    var ticking = false;
    var footerGap = 12;

    function getFooter() {
      return document.querySelector('footer') || document.querySelector('.shopify-section-group-footer-group');
    }

    document.querySelectorAll('.sticky-promo-bar-clogs-spacer').forEach(function (el) {
      el.remove();
    });
    var spacer = document.createElement('div');
    spacer.className = 'sticky-promo-bar-clogs-spacer';
    spacer.style.setProperty('display', 'block', 'important');
    var main = document.querySelector('main');
    var footerEl = getFooter();
    if (main) {
      main.insertAdjacentElement('afterend', spacer);
    } else if (footerEl) {
      footerEl.insertAdjacentElement('beforebegin', spacer);
    }

    function dock() {
      if (bar.parentNode === spacer) return;
      bar.style.position = 'static';
      bar.style.bottom = '';
      bar.style.marginTop = footerGap + 'px';
      spacer.appendChild(bar);
    }

    function undock() {
      if (bar.parentNode !== spacer) return;
      bar.style.position = '';
      bar.style.marginTop = '';
      holder.appendChild(bar);
    }

    function update() {
      ticking = false;
      var viewportHeight = window.innerHeight;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      var holderTop = holder.getBoundingClientRect().top + scrollTop;
      var slotHeight = bar.offsetHeight + footerGap * 2;
      var shouldPin = scrollTop >= holderTop + slotHeight - viewportHeight;

      if (!shouldPin) {
        undock();
        holder.classList.remove('is-pinned');
        holder.style.height = '';
        holder.style.padding = '';
        bar.style.bottom = '';
        spacer.style.height = '0px';
        return;
      }

      holder.classList.add('is-pinned');
      holder.style.height = '0px';
      holder.style.padding = '0px';

      var footer = getFooter();
      var footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      var extra = footer ? Math.max(0, footerTop - spacer.getBoundingClientRect().bottom) : 0;
      spacer.style.height = Math.max(0, bar.offsetHeight + footerGap * 2 - extra) + 'px';

      var lift = viewportHeight - footerTop + footerGap;
      if (lift > 0) {
        dock();
      } else if (lift < -2) {
        undock();
        bar.style.bottom = '';
      }
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, {passive: true});
    window.addEventListener('resize', requestUpdate);

    update();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initStickyPromoBarClogs(document);
  });
} else {
  initStickyPromoBarClogs(document);
}

document.addEventListener('shopify:section:load', function (event) {
  initStickyPromoBarClogs(event.target);
});
